export default __webpack_public_path__ + "static/media/P308.2.a689aedb.mp3";